
    var riot = require('riot')
    import { List } from './gb-list';
riot.tag2('gb-list', '<ul class="{inline: $listable.inline}"> <li data-is="gb-list-item" each="{item, i in $listable.items}" if="{$list.shouldRender(item)}"> <yield></yield> </li> </ul>', 'gb-list.gb-stylish > ul,[data-is="gb-list"].gb-stylish > ul{ list-style: none; margin: 0; padding: 0; } gb-list.gb-stylish > ul > li,[data-is="gb-list"].gb-stylish > ul > li{ margin: 0 10px; } gb-list.gb-stylish > ul.inline > li,[data-is="gb-list"].gb-stylish > ul.inline > li{ display: inline-block; } gb-list.gb-stylish > ul a,[data-is="gb-list"].gb-stylish > ul a{ color: #888; cursor: pointer; } gb-list.gb-stylish > ul a:hover,[data-is="gb-list"].gb-stylish > ul a:hover{ color: black; }', '', function(opts) {
    this._mixin(List);
});

    
  


// WEBPACK FOOTER //
// ./src/tags/list/gb-list.tag.html